<template>
  <v-card class="my-8">
    <v-card-title class="d-flex flex-column align-start mb-3">
      {{ title }}
      <v-chip label>
        <span class="font-weight-regular"> {{ items.length }}</span>
        <span class="mx-1">|</span>
        <span class="font-weight-bold">{{ pendingPrice | currency }}</span
        >&nbsp;
      </v-chip>
    </v-card-title>

    <v-data-table
      v-model="selected"
      :loading="loading"
      :items="items"
      :headers="headers"
      :items-per-page="-1"
      :sort-by="['date']"
      :sort-desc="[true]"
      :show-select="!paused && !completed"
      item-key="jobId"
      class="row-pointer"
      hide-default-footer
      mobile-breakpoint="0"
      @click:row="rowClick"
    >
      <template #[`item.icon`]="{ item }">
        <img
          :src="item.masterAccountFaviconUrl"
          style="width: 24px; height: 24px"
        />
      </template>
      <template #[`item.price`]="{ item }">
        {{ item.price | currency }}
      </template>
      <template #[`item.markup`]="{ item }">
        {{ item.markup | percentage }}
      </template>
      <template #[`item.submitByDate`]="{ item }">
        <div :class="{ 'font-weight-bold': true, 'error--text': paused }">
          {{ item.submitByDate | normalDateWithTime }}
        </div>
      </template>
      <template #[`item.orderDate`]="{ item }">
        {{ item.orderDate | normalDateWithTime }}
      </template>
      <template #[`item.earliestDeliveryDate`]="{ item }">
        {{ item.earliestDeliveryDate | normalDate }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import enums from '@/helpers/enums';
import { sumBy } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'PrintList',

  props: {
    title: { type: String, default: '' },
    data: { type: Array, default: () => {} },
    revenue: { type: Number, default: 0 },
    paused: { type: Boolean, default: false },
    completed: { type: Boolean, default: false },
    loading: { type: Boolean }
  },

  data() {
    return {
      selected: [],
      headers: [
        { text: '', value: 'icon' },
        { text: 'Order Id', value: 'orderId' },
        { text: 'User', value: 'username' },
        { text: 'Price', value: 'price' },
        { text: 'Markup', value: 'markup' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Product', value: 'categoryName' },
        { text: 'Printer', value: 'provider' },
        { text: 'Submit By', value: 'submitByDate' },
        { text: 'Received', value: 'orderDate' },
        { text: 'Deliver Date', value: 'earliestDeliveryDate' },
        { text: 'Snailblast', value: 'snailblastCampaignId' },
        { text: '', value: 'actions' }
      ]
    };
  },

  computed: {
    items() {
      if (!this.data || !this.data.length) {
        return [];
      }
      return this.data.map((x) =>
        Object.assign(x, {
          isSelectable: x.readyToSubmit && !this.paused && !this.completed,
          markup: x.actualMarkup > 0 ? x.actualMarkup : x.estimatedMarkup
        })
      );
    },
    pendingPrice() {
      return sumBy(this.items, 'price');
    },
    ...mapGetters({
      storeSelectedJobs: 'orders/selected_jobs'
    })
  },

  watch: {
    selected(val) {
      this.$store.dispatch('orders/setSelectedJobs', val);
    },
    storeSelectedJobs(val) {
      if (!val.length && this.selected.length) {
        this.selected = [];
      }
    }
  },

  mounted() {
    this.$store.dispatch('orders/setSelectedJobs', []);
  },

  methods: {
    rowClick(item) {
      this.$store.dispatch('drawers/open', {
        drawerId: item.isPromo ? enums.DRAWERS.PROMO_JOB_DETAIL : enums.DRAWERS.PRINT_JOB_DETAIL,
        data: { orderId: item.orderId, jobId: item.jobId }
      });
    }
  }
};
</script>

<style scoped>
>>> .v-icon.notranslate.mdi-checkbox-blank-outline:not(.v-icon--disabled) {
  color: var(--v-mcsprimary-base) !important;
}
</style>
